export enum AppNavigationVariant {
  PRIMARY = 'PRIMARY',
  LIGHT = 'LIGHT',
}
